import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, Observable, share, startWith, switchMap } from 'rxjs';
import { DeliveryForDate } from 'src/app/api/contracts/order';
import { ModalService } from 'src/app/services/modal.service';
import { OrderService } from 'src/app/services/order.service';
import { DeliveryForDateStatus } from 'src/app/types/delivery-for-date';

@Component({
  selector: 'app-todays-deliveries',
  templateUrl: './todays-deliveries.component.html',
  styleUrls: ['./todays-deliveries.component.scss'],
})
export class TodaysDeliveriesComponent implements OnInit {
  private refreshTrigger$ = new BehaviorSubject<void>(undefined);
  public readonly todaysDeliveries$: Observable<DeliveryForDate[]>;

  constructor(
    private readonly orderService: OrderService,
    private readonly modalService: ModalService
  ) {
    // const date = moment('2024-12-20').format('yyy-MM-DD');
    const date = moment().format('yyy-MM-DD');
    this.todaysDeliveries$ = this.refreshTrigger$.pipe(
      switchMap(() => this.orderService.retrieveDeliveriesForDate(date)),
      share()
    );
  }

  ngOnInit() {
    return;
  }

  onConfirmationProcessRequested(barcode: number): void {
    this.openConfirmationModal(barcode);
  }

  private openConfirmationModal(barcode: number): void {
    this.modalService
      .showPickupConfirmationScannerModal(`${barcode}`)
      .subscribe((isSuccess) => {
        if (isSuccess) {
          this.refreshDeliveries();
        }
        this.refreshDeliveries();
      });
  }

  private refreshDeliveries(): void {
    this.refreshTrigger$.next();
  }
}
